class Tooltips {
  constructor() {
    $('[data-bs-toggle="tooltip"]').click(function (event) {
      event.preventDefault();
    });
    $('[data-bs-toggle="tooltip"]').tooltip();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Tooltips();
})
